export const APP_CONFIG = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  APP_NAME: 'Transport CRM',
  DEFAULT_LOCALE: 'pl',
  SUPPORTED_LOCALES: ['pl', 'en'] as const,
} as const;

export type SupportedLocale = (typeof APP_CONFIG.SUPPORTED_LOCALES)[number];
